import { useCurrentUser } from '@qualio/ui-components';
import React from 'react';

export type UserPermissionsContextType = {
  canCUDProduct: boolean;
  canCUDRootCause: boolean;
  canCreateEvent: boolean;
};

export const UserPermissionsContext = React.createContext<UserPermissionsContextType | undefined>(undefined);

export const UserPermissionsProvider: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  const { permissions, userGroups } = useCurrentUser();
  const isQualityUser = userGroups.includes('quality');
  const canCUDProduct = isQualityUser;
  const canCUDRootCause = isQualityUser;
  const canCreateEvent = permissions['can_create_issue'] === true;

  const value = { canCUDProduct, canCUDRootCause, canCreateEvent };
  return <UserPermissionsContext.Provider value={value}>{children}</UserPermissionsContext.Provider>;
};
